module.exports = __webpack_public_path__ + "img/noCollection.46d9f620.png";